import * as React from 'react';

import { useShowMobileAppBanner } from './utils';
import { MobileAppBannerContainer } from '../MobileAppBannerContainer';

export const BannerContainer = () => {
  const showMobileAppBanner = useShowMobileAppBanner();

  // Определяем, показывать ли баннер для скачивания приложения
  if (showMobileAppBanner) {
    return <MobileAppBannerContainer />;
  }

  return null;
};
